import { featureExpoHallConfig } from '@fs/zion-rootstech'

const expoHallConfig = {
  locales: featureExpoHallConfig.locales,
  searchTerms: featureExpoHallConfig.searchTopics,
  promotionsPath: featureExpoHallConfig.promotions.path,
  sponsorsWithDisclaimers: featureExpoHallConfig.sponsors.withDisclaimers,
}
const boothConfig = {
  platinumSponsors: featureExpoHallConfig.sponsors.platinum,
}

export { expoHallConfig, boothConfig }
